module.exports = "/images/calendar.svg?3fd5ca700b47edea16be65d8d6187675";